import { render, staticRenderFns } from "./template_loader.vue?vue&type=template&id=7c1e74d5&"
import script from "./template_loader.vue?vue&type=script&lang=js&"
export * from "./template_loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports